export default "__VITE_ASSET__8222134d__"